import React, { useRef } from "react";
import "../styles/BestPrac.css";
import bestPracticesImage from "../../../../assets/solutions/cloudadoption/bestpractices.png"; // Updated image path

const CopilotSection = () => {
  const textRef = useRef(null);

  return (
    <section className="cloud-backup-sec">
      <div className="cloud-backup-container">
        <div className="cloud-backup-text" ref={textRef}>
          <h1>Best Practices</h1>
          <ul>
            <li>Every migration is mapped to your strategic goals and measurable outcomes.</li>
            <li>We conduct thorough inventory and dependency mapping to ensure nothing is overlooked.</li>
            <li>Security and compliance are built into every step.</li>
            <li>Comprehensive testing and rollback plans safeguard your business.</li>
            <li>We provide continuous optimization and support for peak efficiency.</li>
          </ul>
        </div>
        <div className="cloud-backup-image">
          <img src={bestPracticesImage} alt="Best Practices Cloud" />
        </div>
      </div>
    </section>
  );
};

export default CopilotSection;